module.exports = {
  $document: $(document),
  $body: $('body'),
  $window: $(window),
};
